var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41_4630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4219 49.0234L49.2188 40.3906V0.195312L32.4219 8.78906L17.1875 0.976562L0.390625 9.60938V49.8438L17.1875 41.2109L32.4219 49.0234ZM33.9844 11.4844L46.0938 5.27344V38.4766L33.9844 44.6875V11.4844ZM18.75 5.27344L30.8594 11.4844V44.6875L18.75 38.5156V5.27344ZM15.625 38.5156L3.51562 44.7266V11.5234L15.625 5.3125V38.5156Z",
    fill: "#F2682A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41_4630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUldIcon);
export default __webpack_public_path__ + "static/media/uld-icon.e6f035c743dc760f7c741d5e38787842.svg";
export { ForwardRef as ReactComponent };